import type { ReactNode } from "react"

import { SettingsProvider } from "@/contexts/settings-context"
import { SidebarProvider } from "@/components/ui/sidebar"
import { DirectionProvider } from "./direction-provider"
import { ModeProvider } from "./mode-provider"
import { ThemeProvider } from "./theme-provider"

export function Providers({
  children,
}: Readonly<{
  children: ReactNode
}>) {
  return (
    <SettingsProvider>
      <ModeProvider>
        <ThemeProvider>
          <DirectionProvider>
            <SidebarProvider
              style={{ "--sidebar-width-icon": "5.1875rem" } as React.CSSProperties}
            >
              {children}
            </SidebarProvider>
          </DirectionProvider>
        </ThemeProvider>
      </ModeProvider>
    </SettingsProvider>
  )
}
